const supply = [
  [
    "Labels",
    "Plain and printed labels for every industry and application.",
    "https://cdn.shopify.com/s/files/1/0991/5927/7916/files/ChatGPT_Image_Jul_30_2026_03_10_26_PM.png?v=1785407005"
  ],
  [
    "Packaging",
    "Bespoke and stock packaging solutions for all businesses.",
    "https://cdn.shopify.com/s/files/1/0991/5927/7916/files/ChatGPT_Image_Jul_30_2026_03_16_22_PM.png?v=1785407005"
  ],
  [
    "Envelopes",
    "Standard and bespoke envelopes in all sizes, styles and finishes.",
    "https://cdn.shopify.com/s/files/1/0991/5927/7916/files/ChatGPT_Image_Jul_30_2026_03_22_02_PM.png?v=1785407005"
  ],
  [
    "Print",
    "High-quality print for business, marketing and promotional use.",
    "https://cdn.shopify.com/s/files/1/0991/5927/7916/files/ChatGPT_Image_Jul_30_2026_03_19_58_PM.png?v=1785407005"
  ],
  [
    "Signage",
    "Professional signage solutions for indoor, outdoor and vehicles.",
    "https://cdn.shopify.com/s/files/1/0991/5927/7916/files/ChatGPT_Image_Jul_30_2026_03_16_29_PM.png?v=1785407003"
  ],
  [
    "Workwear",
    "Workwear and uniform solutions with branding that works for you.",
    "https://cdn.shopify.com/s/files/1/0991/5927/7916/files/ChatGPT_Image_Jul_30_2026_03_17_55_PM.png?v=1785407006"
  ],
  [
    "Paper & More",
    "Paper, office supplies and more to keep your business moving.",
    "https://cdn.shopify.com/s/files/1/0991/5927/7916/files/ChatGPT_Image_Jul_30_2026_03_37_10_PM.png?v=1785407880"
  ]
];

const why = [
  ["One Point of Contact", "Simplify your supply chain with one trusted procurement partner.", '<circle cx="12" cy="8" r="3.5"/><path d="M5 20a7 7 0 0 1 14 0"/>'],
  ["Cost Savings", "We compare suppliers to secure the best possible prices.", '<circle cx="12" cy="12" r="9"/><path d="M14 8.5A2.8 2.8 0 0 0 9.6 10c0 3 .4 4.5-1.1 6h5.9M9 12.5h4"/>'],
  ["UK & European Supply", "Access to a wide network of approved and reliable manufacturers.", '<circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18Z"/>'],
  ["Fast Quotes", "Receive competitive quotations quickly and efficiently.", '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>'],
  ["Reliable & Proven", "We work with established manufacturers you can trust.", '<path d="M12 3 5 6v6c0 4.4 3 7.9 7 9 4-1.1 7-4.6 7-9V6Z"/><path d="m9 12 2 2 4-4"/>'],
];

const svg = (paths) => `<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round">${paths}</svg>`;

document.getElementById("supplyGrid").innerHTML = supply
  .map(
    ([t, d, image]) => `
      <article class="card reveal">
        <img
          class="supply-card-image"
          src="${image}"
          alt="${t}"
          loading="lazy"
        >
        <h3>${t}</h3>
        <p>${d}</p>
      </article>
    `
  )
  .join("");

document.getElementById("whyGrid").innerHTML = why
  .map(([t, d, i]) => `<div class="why-item reveal">${svg(i)}<h3>${t}</h3><p>${d}</p></div>`)
  .join("");

// mobile nav
const header = document.getElementById("header");
document.getElementById("burger").addEventListener("click", () => header.classList.toggle("open"));
document.getElementById("nav").addEventListener("click", (e) => {
  if (e.target.tagName === "A") header.classList.remove("open");
});

// =========================================
// SCROLL REVEAL ANIMATION
// =========================================

document.addEventListener("DOMContentLoaded", () => {

  // -----------------------------------------
  // Add reveal classes to page sections
  // -----------------------------------------

  const revealElements = [
    // Main sections
    ".section",
    ".why",
    ".trusted",
    ".contact",

    // Section content
    ".section .eyebrow",
    ".section h2",
    ".section .rule",

    ".trusted .head",
    ".contact h2",
    ".contact .rule",
    ".contact .lead",
    ".contact ul",
    ".contact .form",

    // Trusted logos
    ".trusted .logos > div"
  ];

  revealElements.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      el.classList.add("reveal");
    });
  });


  // -----------------------------------------
  // Intersection Observer
  // -----------------------------------------

  const observer = new IntersectionObserver(
    (entries) => {

      entries.forEach(entry => {

        if (entry.isIntersecting) {
          entry.target.classList.add("in");

          // Optional:
          // Stop observing after animation happens
          observer.unobserve(entry.target);
        }

      });

    },
    {
      threshold: 0.15,
      rootMargin: "0px 0px -50px 0px"
    }
  );


  // -----------------------------------------
  // Observe all reveal elements
  // -----------------------------------------

  document.querySelectorAll(
    ".reveal, .reveal-left, .reveal-right, .reveal-scale"
  ).forEach((el, index) => {

    // Stagger animation
    el.style.transitionDelay = `${(index % 6) * 80}ms`;

    observer.observe(el);

  });


  // =========================================
  // HEADER ANIMATION
  // =========================================

  const header = document.getElementById("header");

  if (header) {

    // Header appears when page loads
    setTimeout(() => {
      header.classList.add("header-visible");
    }, 150);


    // Header shadow/background when scrolling
    const handleHeaderScroll = () => {

      if (window.scrollY > 30) {
        header.classList.add("header-scrolled");
      } else {
        header.classList.remove("header-scrolled");
      }

    };

    window.addEventListener("scroll", handleHeaderScroll, {
      passive: true
    });

    handleHeaderScroll();

  }

});

// form
const form = document.getElementById("quoteForm");
form.addEventListener("submit", () => {
  
  const required = [...form.querySelectorAll("[required]")];
  const invalid = required.find((f) => !f.value.trim() || (f.type === "email" && !/^\S+@\S+\.\S+$/.test(f.value)));
  if (invalid) {
    invalid.focus();
    invalid.style.outline = "2px solid #c0392b";
    setTimeout(() => (invalid.style.outline = ""), 1600);
    return;
  }
  document.getElementById("formNote").classList.add("show");
  form.reset();
});
